import {
    getUnifiedReviewHistory,
    getUnifiedReviewRecords,
    saveUnifiedReviewBatchDecision,
    saveUnifiedReviewDecision,
    UNIFIED_RISK_TYPE,
} from "@/api/unifiedReviewWorkbench";

function normalizeCaseNoList(value) {
    if (Array.isArray(value)) {
        return value.filter(Boolean).join(",");
    }
    if (value === null || value === undefined) {
        return "";
    }
    return String(value)
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean)
        .join(",");
}

function mapRiderThirdPartyRecord(record = {}) {
    const detailPayload = record.detailPayload || {};
    const relatedCaseNoList = normalizeCaseNoList(record.relatedCaseNoList);
    const riderCaseNoList = normalizeCaseNoList(detailPayload.riderCaseNoList);
    const thirdPartyCaseNoList = normalizeCaseNoList(detailPayload.thirdPartyCaseNoList);
    const validCaseCount = Number(detailPayload.validCaseCount || record.caseCount || 0);
    return {
        ...record,
        idCard: record.bizKey,
        validCaseCount,
        riderCaseCount: detailPayload.riderCaseCount || record.extNum1,
        thirdPartyCaseCount: detailPayload.thirdPartyCaseCount || record.extNum2,
        roleSummary: detailPayload.roleSummary || record.extStr1,
        riderCaseNoList,
        thirdPartyCaseNoList,
        allCaseNoList: relatedCaseNoList,
        totalPayAmount: record.totalAmount,
        amountCompleteFlag: record.extFlag1,
        excludeFlags: (record.excludePayload && record.excludePayload.summary) || detailPayload.excludeFlags,
        ruleSummary: (record.rulePayload && record.rulePayload.summary) || detailPayload.ruleSummary,
        reviewStatus: record.reviewDecision || record.reviewStatus || "pending",
        lastReasonCode: record.reasonCode || record.lastReasonCode,
        lastReasonDesc: record.reasonDesc || record.lastReasonDesc,
        reviewUpdatedAt: record.reviewedAt || record.updatedAt,
    };
}

function mapRiderThirdPartyHistory(item = {}) {
    return {
        ...item,
        historyId: item.reviewHistoryId || item.historyId,
        beforeReviewStatus: item.beforeReviewDecision || item.beforeReviewStatus,
        afterReviewStatus: item.afterReviewDecision || item.afterReviewStatus,
        afterAllCaseNoList: item.snapshotPayload?.afterAllCaseNoList || item.afterAllCaseNoList,
    };
}

export function getRiderThirdPartyReviewRecords(apiBaseurl = "", params = {}, httpClient) {
    return getUnifiedReviewRecords(apiBaseurl, {
        riskType: UNIFIED_RISK_TYPE.RIDER_THIRD_PARTY,
        reviewStatus: params.reviewStatus || "all",
        reviewDecision: params.reviewDecision || "all",
        pageNo: params.pageNo || 1,
        pageSize: params.pageSize || 20,
        extFilter1: params.amountComplete || "all",
    }, httpClient, mapRiderThirdPartyRecord);
}

export function getRiderThirdPartyReviewHistory(apiBaseurl = "", reviewRecordId, httpClient) {
    return getUnifiedReviewHistory(apiBaseurl, reviewRecordId, httpClient, mapRiderThirdPartyHistory);
}

export function saveRiderThirdPartyReviewDecision(apiBaseurl = "", reviewRecordId, payload = {}, httpClient) {
    return saveUnifiedReviewDecision(apiBaseurl, reviewRecordId, payload, httpClient, mapRiderThirdPartyRecord);
}

export function saveRiderThirdPartyReviewBatchDecision(apiBaseurl = "", payload = {}, httpClient) {
    return saveUnifiedReviewBatchDecision(apiBaseurl, {
        riskType: UNIFIED_RISK_TYPE.RIDER_THIRD_PARTY,
        riskEventIds: payload.reviewRecordIds || [],
        decision: payload.decision,
        decisionNote: payload.decisionNote,
    }, httpClient);
}

export const __test__ = {
    mapRiderThirdPartyRecord,
    normalizeCaseNoList,
};
